/* eslint-disable @typescript-eslint/no-unused-vars */
import { atom } from "jotai";
import { atomFamily } from "jotai-family";
import { isEqual } from "lodash-es";
import type { ImageUrl } from "./preview-family";

export const imageUrlOverrideFamily = atomFamily(
  ({
    // These vars are unused, but they are required by the atomFamily
    // in order to retain state so that we can move between images.
    formatId,
    imgNum,
    answer,
    fileId,
  }: {
    formatId: string;
    imgNum: number;
    answer: string;
    fileId?: string;
  }) => {
    return atom<ImageUrl[] | null>(null);
  },
  isEqual,
);
